export * from './platform/default/storyboard.constants';

export const STORYBOARD_DISPLAY_DURATION = 3000;

export const ORIGIN_IMAGE_W = 60000;

export const FRAME_Y = 0;
export const FRAME_W = 200;
export const FRAME_H = 112;

export const FRAMES_COUNT = 300;
